import React, { useEffect, useState } from 'react';
import MultipleProductPlan from './multipleProductPlan';
import SingleProductPlan from './singleProductPlan';
import MultipleRCGProductPlan from './multipleRCGProductPlan';
import SompoProductPlan from './sompoProductPlan';

import { uniqBy } from 'lodash';

const Table = (props) => {
  const [coverages, setCoverages] = useState([]);
  const [option, setOption] = useState(props?.selectedOption !== null ? props.selectedOption : null);
  const [expanded, setExpanded] = useState(props?.readOnlyMode);
  const [productPlanName, setProductPlanName] = useState(null);

  const parseNumber = (value) => {
    if (typeof (value) === 'string') {
      if (value.startsWith('%')) return Number(value.replaceAll('%', '').replaceAll(',', '.'))

      return Number(value.replaceAll('R$', '').replaceAll('.', '').replaceAll(',', '.'))
    }
    return value
  }

  const currencyMask = (maxValue, minValue) => ({
    "type": "currency",
    "mask": 0,
    "scale": 2,
    "signed": false,
    "normalizeZeros": false,
    "padFractionalZeros": true,
    "radix": ",",
    "thousandsSeparator": ".",
    "mapToRadix": [
      ".",
      ","
    ],
    "max": maxValue || 999999999999999,
    "min": minValue || 0
  })

  const groupCoverageItems = () => {
    let coverageItems = [];
    if (+props?.idProduct === 28 && props.calcList[0]?.coverageCalcList) {
      for (const calc of props.calcList) {
        coverageItems.push(...calc.coverageCalcList)
      }

      coverageItems = uniqBy(coverageItems, 'idProductPlan').map(plan => {
        plan.coverageItems = plan.coverageItems.sort(
          (a, b) => a.coverageDomain - b.coverageDomain
        );
        return plan;
      });
    } else {
      if (!props.calcList[0].coverageItems?.length) return;

      const arrCoverage = coverages
      props.calcList.map(calcListItems => {
        setProductPlanName(calcListItems.productPlanName)
        calcListItems.coverageItems.map(item => {
          arrCoverage.push(item)
        })
      });

      coverageItems = Array.from(new Set(arrCoverage.map(a => a.idCoverage))).map(id => {
        return arrCoverage.find(a => a.idCoverage === id)
      }).sort((a, b) => a.coverageDomain - b.coverageDomain)
    }

    setCoverages(coverageItems)
  }

  const showOption = (index) => {
    if (!expanded) {
      setOption(index);
      setExpanded(true)
      props?.onSelectedOptIndex && props.onSelectedOptIndex(index)
    } else {
      setOption(null);
      setExpanded(false)
      props?.onSelectedOptIndex && props.onSelectedOptIndex(null)
    }
  };

  useEffect(() => {
    if (props.calcList.length) groupCoverageItems()
  }, [props.calcList]);

  const handleComponentRender = (type) => {
    switch (type) {
      case 'multipleProductPlan':
        return <MultipleProductPlan
          props={props}
          coverages={coverages}
          option={option}
          expanded={expanded}
          showOption={showOption}
          parseNumber={parseNumber}
          currencyMask={currencyMask}
        />
      case 'singleProductPlan':
        return <SingleProductPlan
          props={props}
          productPlanName={productPlanName}
          coverage={coverages}
          option={option}
          expanded={expanded}
          showOption={showOption}
          parseNumber={parseNumber}
          currencyMask={currencyMask}
        />
      case 'multipleRCGProductPlan':
        return <MultipleRCGProductPlan
          props={props}
          productPlanCoverage={coverages}
          option={option}
          expanded={expanded}
          showOption={showOption}
          parseNumber={parseNumber}
          currencyMask={currencyMask}
        />
      case 'sompoProductPlan':
        return <SompoProductPlan
          productPlanCoverage={coverages}
          option={option}
          expanded={expanded}
          showOption={showOption}
          parseNumber={parseNumber}
          currencyMask={currencyMask}
          {...props}
        />
      default:
        return <></>
    }
  }

  return handleComponentRender(props.componentTypeRender);
}

export default Table;